/**
 * @global
 * @namespace
 */
const BasicModeration = (function ()
{

	function hide(element, endpoint, warning)
	{
		if (typeof element === "string") {
			warning = endpoint;
			endpoint = element;
		}
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function show(element, endpoint, warning)
	{
		if (typeof element === "string") {
			warning = endpoint;
			endpoint = element;
		}
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function lockChallenge(element, endpoint, warning)
	{
		if (typeof element === "string") {
			warning = endpoint;
			endpoint = element;
		}
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function unlockChallenge(element, endpoint, warning)
	{
		if (typeof element === "string") {
			warning = endpoint;
			endpoint = element;
		}
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function lockIdea(element, endpoint, warning)
	{
		if (typeof element === "string") {
			warning = endpoint;
			endpoint = element;
		}
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function unlockIdea(element, endpoint, warning)
	{
		if (typeof element === "string") {
			warning = endpoint;
			endpoint = element;
		}
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function pinIdea(element, endpoint)
	{
		if (typeof element === "string") {
			endpoint = element;
		}
		_executeGetEndpoint(endpoint, function ()
		{
			mvvm.doSubmit(null, "__RESET", null, null, null);
		});
	}

	function unpinIdea(element, endpoint)
	{
		if (typeof element === "string") {
			endpoint = element;
		}
		_executeGetEndpoint(endpoint, function ()
		{
			mvvm.doSubmit(null, "__RESET", null, null, null);
		});
	}

	function _showWarningAndExecuteGetEndpoint(endpoint, warning, success)
	{
		showConfirmPopup(warning, function ()
		{
			_executeGetEndpoint(endpoint, function ()
			{
				mvvm.doSubmit(null, "__RESET", null, null, null);
			});
		});
	}

	function _executeGetEndpoint(endpoint, success)
	{
		dataAction.callClientGetEndpoint(
			endpoint,
			success,
			_errorHandler,
		);
	}

	function _errorHandler(error)
	{
		var message = error.responseJSON && error.responseJSON.message ? error.responseJSON.message : error.statusText;
		showErrorPopup(message);
	}

	return {
		hide: hide,
		show: show,
		lockChallenge: lockChallenge,
		unlockChallenge: unlockChallenge,
		lockIdea: lockIdea,
		unlockIdea: unlockIdea,
		pinIdea: pinIdea,
		unpinIdea: unpinIdea,
	};
}());
